import React from 'react';
import { Provider as PaperProvider, DefaultTheme } from 'react-native-paper';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { HelmetProvider } from 'react-helmet-async';
import CalculatorHubScreen from './src/screens/CalculatorHubScreen';

const theme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    primary: '#4a3975',
    secondary: '#e67e7e',
    background: '#f8f9fa',
    surface: '#ffffff',
    text: '#333333',
    onSurface: '#333333',
    onBackground: '#333333',
  },
};

export default function App() {
  return (
    <SafeAreaProvider>
      <PaperProvider theme={theme}>
        <HelmetProvider>
          <CalculatorHubScreen />
        </HelmetProvider>
      </PaperProvider>
    </SafeAreaProvider>
  );
}
